import 'babel-polyfill';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import AppRouter from './components/AppRouter';
import history from './history';
import store from './store';

window.onbeforeunload = () => {
    return store.getState().app.texts['popup.leave.page.copy'];
};

// remove synced configurations
window.onunload = () => {
    // only clear pen configurator localStorage items
    // leave UC (user centrics) items untouched
    const penConfiguratorSettingsKeys = Object.keys(localStorage).filter(item => !item.startsWith('uc_'));
    penConfiguratorSettingsKeys.forEach(item => {
        localStorage.removeItem(item);
    })
};

render(
    <Provider store={store}>
        <Router history={history}>
            <AppRouter store={store} />
        </Router>
    </Provider>,
    document.getElementById('app')
);
